import React, { useEffect, useState } from 'react';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useDispatch, useSelector } from 'react-redux';
import { getAccessDeniedError } from '../../Reducers/App/Selectors';
import { clearAccessDeniedError } from '../../Reducers/App/Actions';

const MESSAGE_KEY_BY_IDENTIFIER: Record<string, string> = {
  NO_SYSTEM_ACCESS: 'accessDenied.noAccess',
  NO_MACHINE_TYPE_ACCESS: 'accessDenied.noSystemAccess',
  NO_REGION_ACCESS: 'accessDenied.noRegionAccess',
  SESSION_EXPIRED: 'accessDenied.sessionExpired',
};

export const AccessDeniedDialog = () => {
  const accessDeniedError = useSelector(getAccessDeniedError);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (accessDeniedError) setOpen(true);
  }, [accessDeniedError]);

  const dispatch = useDispatch();

  const close = () => {
    setOpen(false);
    dispatch(clearAccessDeniedError());
  };

  const messageKey = MESSAGE_KEY_BY_IDENTIFIER[accessDeniedError] ?? 'accessDenied.noAccess';

  return (
    <CustomDialog
      open={open}
      aria-labelledby="access-denied-dialog-title"
      aria-describedby="access-denied-dialog-description"
      dialogTitle={t('accessDenied.title')}
      onCancel={close}
    >
      <DialogContent>{t(messageKey)}</DialogContent>
      <DialogActions>
        <MainButton onClick={close}>{t('accessDenied.closeButtonLabel')}</MainButton>
      </DialogActions>
    </CustomDialog>
  );
};
